import React from 'react';
import { TransactionId } from '@sovryn/ui';
import { useCopyAddress } from '../../../hooks/useCopyAddress';
export const TxIdWithNotification = props => {
    const onCopyAddress = useCopyAddress();
    return React.createElement(TransactionId, Object.assign({}, props, { onCopyAddress: onCopyAddress }));
};
